import { createAggregatedClient } from "@smithy/smithy-client";
import { DeleteThingShadowCommand, } from "./commands/DeleteThingShadowCommand";
import { GetRetainedMessageCommand, } from "./commands/GetRetainedMessageCommand";
import { GetThingShadowCommand, } from "./commands/GetThingShadowCommand";
import { ListNamedShadowsForThingCommand, } from "./commands/ListNamedShadowsForThingCommand";
import { ListRetainedMessagesCommand, } from "./commands/ListRetainedMessagesCommand";
import { PublishCommand } from "./commands/PublishCommand";
import { UpdateThingShadowCommand, } from "./commands/UpdateThingShadowCommand";
import { IoTDataPlaneClient } from "./IoTDataPlaneClient";
const commands = {
    DeleteThingShadowCommand,
    GetRetainedMessageCommand,
    GetThingShadowCommand,
    ListNamedShadowsForThingCommand,
    ListRetainedMessagesCommand,
    PublishCommand,
    UpdateThingShadowCommand,
};
export class IoTDataPlane extends IoTDataPlaneClient {
}
createAggregatedClient(commands, IoTDataPlane);
